site.simpleMap = {
	init: function () {
		var point = [64.151100, -21.946500],
			zoom = 20;
		var map = L.map('map', {
			scrollWheelZoom:false,
			fullscreenControl: true
		}).setView(point, zoom);
		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
		}).addTo(map);
		map.zoomControl.setPosition('bottomright');
		var markerIcon = L.icon({
			iconUrl: '/static/themes/2015/images/map-pin.png',
			iconSize: [73, 73],
			iconAnchor: [17, 51]
		});
		L.marker(point, {
			icon: markerIcon,
			title: 'Slippbarinn'
		}).addTo(map);
	}
};

site.inits.push('site.simpleMap.init()');